import { render, staticRenderFns } from "./loginVerification.vue?vue&type=template&id=7e958b7a&scoped=true&"
import script from "./loginVerification.vue?vue&type=script&lang=js&"
export * from "./loginVerification.vue?vue&type=script&lang=js&"
import style0 from "./loginVerification.vue?vue&type=style&index=0&id=7e958b7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e958b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e958b7a')) {
      api.createRecord('7e958b7a', component.options)
    } else {
      api.reload('7e958b7a', component.options)
    }
    module.hot.accept("./loginVerification.vue?vue&type=template&id=7e958b7a&scoped=true&", function () {
      api.rerender('7e958b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginVerification.vue"
export default component.exports